module.exports = __webpack_public_path__ + "static/img/1.755c4e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/1.png
// module id = 3vn6
// module chunks = 0